import { render, staticRenderFns } from "./GenericButtonCta.vue?vue&type=template&id=61c0fd70"
import script from "./GenericButtonCta.vue?vue&type=script&lang=js"
export * from "./GenericButtonCta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports